import type { CardDateType } from './firestore/card';

/** Standard date types (excluding custom) */
export const CARD_DATE_TYPES: CardDateType[] = [
  'delivery',
  'launch',
  'internal-review',
  'stakeholder-review',
  'publish',
];

export const CARD_DATE_TYPE_LABELS: Record<CardDateType, string> = {
  delivery: 'Delivery',
  launch: 'Launch',
  'internal-review': 'Internal Review',
  'stakeholder-review': 'Stakeholder Review',
  publish: 'Publish',
  custom: 'Custom',
};
